import ArticlesTypesTabs from './ArticlesTypesTabs';

export default ArticlesTypesTabs;
